import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginTop: 8,
    marginBottom: 8,
    paddingTop: 0,
    borderRadius: 16,
    backgroundColor: theme.palette.background.default,
  },
  title: {
    fontSize: 12,
  },
  progressVariantDark: {
    height: 10,
    borderRadius: 5,
    '& .MuiLinearProgress-barColorPrimary': {
      backgroundColor: theme.palette.secondary.main,
    },
  },
  progressVariantLight: {
    height: 10,
    borderRadius: 5,
    '& .MuiLinearProgress-barColorPrimary': {
      backgroundColor: theme.palette.secondary.light,
    },
  },
}));
